export interface ArticleDetail {
  slug: string;
  title: string;
  summary: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  image: string;
  content: string;
  stats: {
    reads: string;
    comments: string;
    likes: string;
    trackDays: string;
  };
}

export const articleDetails: Record<string, ArticleDetail> = {
  'wanghong-sishenghuo': {
    slug: 'wanghong-sishenghuo',
    title: '某顶流网红被曝私生活混乱',
    summary: '多位知情人实名爆料，涉及多名异性关系，聊天记录、转账记录和私密照片逐一浮出水面。',
    category: '网红翻车',
    categorySlug: 'wanghong-fanche',
    author: '爆料组A',
    date: '2026-07-06',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20private%20club%20interior%20with%20velvet%20curtains%20and%20warm%20amber%20chandelier%20lighting%2C%20mysterious%20luxury%20atmosphere%2C%20cinematic%20composition%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20abstract%20metaphor%20for%20scandal&width=1600&height=800&seq=article-hero-sishenghuo&orientation=landscape',
    content: `
<h3>事件概述</h3>
<p>近日，某平台头部网红被多位知情人士联名爆料，涉及大量私生活混乱细节。据爆料者称，该网红在与现任伴侣交往期间，同时与多名异性保持暧昧关系，且涉及金钱往来。</p>

<h3>爆料内容</h3>
<p>爆料者提供了完整的聊天记录截图，显示该网红在多个社交平台上使用不同身份与不同对象互动。其中一段聊天记录显示，该网红在与某异性聊天时使用了极为露骨的语言，并主动发送私密照片。</p>

<p>此外，银行转账记录也被一并曝光。多位爆料者提供了总计超过30万元的转账记录，转账时间跨度长达一年之久。每笔转账均附有备注说明用途，部分内容不堪入目。</p>

<h3>当事人回应</h3>
<p>截至目前，该网红尚未对爆料内容做出正面回应。其工作室仅发布了一份简短声明，称"网络不实信息泛滥，请大家不信谣、不传谣"，但未对具体指控进行反驳。</p>

<h3>平台处理</h3>
<p>事件发生24小时内，该网红的社交平台评论区已被关闭。多家合作品牌陆续宣布暂停与其合作，其中包括某知名美妆品牌和某奢侈品牌。</p>

<h3>舆论反应</h3>
<p>事件在微博引发超过50万条讨论，相关话题阅读量突破2亿。多数网友表示震惊，认为该网红此前精心打造的"纯情人设"与爆料内容形成巨大反差。</p>
    `,
    stats: {
      reads: '42万+',
      comments: '1.2万+',
      likes: '89%',
      trackDays: '3',
    },
  },
  'nvxing-mihui': {
    slug: 'nvxing-mihui',
    title: '知名女星深夜密会神秘男子',
    summary: '独家偷拍画面首次曝光，两人举止亲密，疑似恋人关系。',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    author: '狗仔队老王',
    date: '2026-07-05',
    image: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20restaurant%20exterior%20at%20night%20with%20warm%20golden%20light%20through%20frosted%20windows%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20secret%20meeting%20vibe&width=1600&height=800&seq=article-hero-mihui&orientation=landscape',
    content: `
<h3>事件概述</h3>
<p>据可靠消息源透露，某知名女星于上周深夜现身某高档餐厅，与一名神秘男子共进晚餐。两人举止亲密，用餐过程中多次牵手，疑似恋人关系。</p>

<h3>独家画面</h3>
<p>本站点记者获得独家偷拍画面，清晰记录了两人在餐厅内的互动细节。画面显示，两人用餐约两小时后一同离开餐厅，随后驱车前往女星住所方向。</p>

<p>值得注意的是，该女星此前公开宣称"单身独居"，多次在采访中表示享受一个人的生活。此次深夜密会与此前的公开表态形成鲜明对比。</p>

<h3>男子身份</h3>
<p>经多方打探，该神秘男子疑似某知名投资机构合伙人，身家超过十位数。两人在半年前的一场慈善晚宴上首次相识，此后被多次目击同时出现在不同场合。</p>

<h3>粉丝反应</h3>
<p>事件曝光后，该女星粉丝群体反应强烈。一部分粉丝表示祝福，认为成年人有恋爱的自由；另一部分粉丝则感到失望，指责其在公开声明中"欺骗粉丝感情"。</p>

<h3>后续发展</h3>
<p>目前该女星尚未对事件做出任何回应。其经纪团队在与本站点记者沟通时表示"艺人的私生活属于个人范畴，不便置评"。</p>
    `,
    stats: {
      reads: '67万+',
      comments: '2.8万+',
      likes: '76%',
      trackDays: '5',
    },
  },
  'zhubo-fanche': {
    slug: 'zhubo-fanche',
    title: '大主播带货翻车粉丝集体维权',
    summary: '涉事金额高达数千万元，产品虚假宣传，退货无门，粉丝集体维权中。',
    category: '网红翻车',
    categorySlug: 'wanghong-fanche',
    author: '消费维权组',
    date: '2026-07-05',
    image: 'https://readdy.ai/api/search-image?query=Dark%20warehouse%20scene%20with%20stacked%20cardboard%20boxes%20and%20warm%20amber%20overhead%20light%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20broken%20promises%20metaphor&width=1600&height=800&seq=article-hero-daihuo&orientation=landscape',
    content: `
<h3>事件概述</h3>
<p>某头部带货主播在最新一场直播中推销的"神奇精华液"引发大量消费者投诉。产品实际成分与宣传严重不符，多名用户使用后出现皮肤过敏反应。</p>

<h3>虚假宣传</h3>
<p>直播中该主播声称产品含有"瑞士进口专利成分"，能够"7天焕肤"。但专业检测机构出具的分析报告显示，该产品实际成分主要为甘油和香精，与宣传完全不符。</p>

<h3>消费者维权</h3>
<p>截至目前，已有超过3000名消费者加入维权群，合计涉事金额超过2000万元。消费者反映，直播间承诺的"7天无理由退货"在申请时被以各种理由拒绝。</p>

<p>某消费者表示："花了899块钱买的套装，用了第二天脸上就起红疹了。找客服退货，说开封了不能退，但不开封怎么用？"

<h3>监管部门介入</h3>
<p>当地市场监管部门已介入调查，对该主播所属公司进行了突击检查。初步调查结果显示，该公司存在多项违规行为，可能面临高额罚款。</p>

<h3>行业影响</h3>
<p>此次事件再次引发公众对直播带货行业的信任危机。业内专家指出，行业亟需建立更严格的审核机制，杜绝虚假宣传行为。</p>
    `,
    stats: {
      reads: '31万+',
      comments: '8900+',
      likes: '92%',
      trackDays: '4',
    },
  },
};

export function getAllArticles(): { slug: string; title: string; category: string; categorySlug: string; image: string; date: string }[] {
  return Object.values(articleDetails).map((a) => ({
    slug: a.slug,
    title: a.title,
    category: a.category,
    categorySlug: a.categorySlug,
    image: a.image,
    date: a.date,
  }));
}

export function getArticleBySlug(slug: string): ArticleDetail | undefined {
  return articleDetails[slug];
}